export const URL_SAVED_VISUALIZATION = '/save-graphs/:project_id';
export const URL_DELETE_VISUALIZATION_BY_ID = '/save-graphs/:project_id/:id';
export const URL_GET_VISUALIZATION_BY_ID = '/save-graphs/:project_id/:id';
export const URL_GET_VISUALIZATION_STYLES_BY_ID = '/save-graphs/left-bar/:project_id/:id';
